class UIService {

	keepFooterStatic = false;

	resetHeaderFooter() {
	    //console.log('reseting header footer');
	    this.keepFooterStatic = false;
	    document.getElementById('nav-menu').setAttribute('class', '');
	    var mainContent = document.getElementById('main-content-container');
	    if (mainContent) {
	    	mainContent.style.marginTop = '0px';
	    }
	    document.getElementsByTagName('footer')[0].setAttribute('class', 'footer');
	    this.adjustHeaderFooter();
  	}

    adjustHeaderFooter(): void {
	    var body = document.body;
	    //console.log('--> adjusting header footer');
	    var y = body.scrollTop || document.documentElement.scrollTop;
	    if (y > 100 && (body.scrollHeight > window.innerHeight + 200)) {
	      document.getElementById('nav-menu').setAttribute('class', 'nav-menu-fixed');
	      var mainContent = document.getElementById('main-content-container');
	      if (mainContent) {
	      	mainContent.style.marginTop = '67px';
	      }
	    } else if (y < 100) {
	      document.getElementById('nav-menu').setAttribute('class', '');
	      mainContent = document.getElementById('main-content-container');
	      if (mainContent) {
	      	mainContent.style.marginTop = '0px';
	      }
	    }

	    if (this.keepFooterStatic && ((body.scrollHeight - y) > (window.innerHeight + 90))) {
	      this.keepFooterStatic = false;
	    }
	    if ((body.scrollHeight - y) > (window.innerHeight + 30) && !this.keepFooterStatic) {
	      document.getElementsByTagName('footer')[0].setAttribute('class', 'footer');
	    } else if (body.scrollHeight > window.innerHeight) {
	      this.keepFooterStatic = true;
	      document.getElementsByTagName('footer')[0].setAttribute('class', 'footer-static');
	    }

	    if (body.scrollHeight === window.innerHeight) {
	   	  let containerTags = document.getElementsByClassName('container');
	   	  if (!containerTags[0]) {
	      	this.keepFooterStatic = false;
	      	document.getElementsByTagName('footer')[0].setAttribute('class', 'footer');
	      } else {
			let containerHeight = containerTags[0].offsetHeight;
			if (containerHeight > window.innerHeight - 185) {
				this.keepFooterStatic = true;
	      		document.getElementsByTagName('footer')[0].setAttribute('class', 'footer-static');
			} else {
				this.keepFooterStatic = false;
	      		document.getElementsByTagName('footer')[0].setAttribute('class', 'footer');	
			}
	      }
	    }
    }

    adjustImageContainerHeights(imagesPage: boolean, numImages: number) {
    	let imageLoadTracker = setInterval(() => {
		    console.log('in adjust container heights');
		    let imgTags = document.getElementsByTagName('img');
		    let loaded = 0;
		    for (let i = 0; i < imgTags.length; i++) {
		        if (imgTags[i].complete) {
		          loaded++
		        }
		    }
		   	//console.log('loaded: ' + loaded + ', image tags: ' + imgTags.length + ', out of: ' + numImages);
		    if (loaded >= imgTags.length) {
		    	console.log('loaded: ' + loaded + ', image tags: ' + imgTags.length + ', out of: ' + numImages);
		        if ((!numImages || (numImages && loaded >= numImages)) || !imagesPage) {
		          clearInterval(imageLoadTracker);
		        } else {
		          return;
		        }
		        let containerTags = document.getElementsByClassName('container');
		        let largestContainer = 0;
		        for (let j = 0; j < containerTags.length; j++) {
		          containerTags[j].style.height = 'auto';
		          if (largestContainer < containerTags[j].offsetHeight) {
		            largestContainer = containerTags[j].offsetHeight;
		          }
		        }
		        if (largestContainer < window.innerHeight - 185) {
		          largestContainer = window.innerHeight - 185;
		        }
		        for (let k = 0; k < containerTags.length; k++) {
		          //console.log('comparing: ' + largestContainer + ' : ' + containerTags[k].offsetHeight);
		          containerTags[k].style.height = largestContainer + 'px';
		        }
		        //console.log('finished adjusting image sizes');
		        this.resetHeaderFooter();

		        //var doneLoadingImagesEv = new Event('doneLoadingImages');
		        var doneLoadingImagesEv = document.createEvent('Event');
				doneLoadingImagesEv.initEvent('doneLoadingImages', true, false);
		        window.dispatchEvent(doneLoadingImagesEv);
		    }
		}, 10);
	}
}

export default UIService;



/** WEBPACK FOOTER **
 ** ./src/AppUIService.js
 **/